import { render, staticRenderFns } from "./WaitPick.vue?vue&type=template&id=c76e1b9c&scoped=true&"
import script from "./WaitPick.vue?vue&type=script&lang=js&"
export * from "./WaitPick.vue?vue&type=script&lang=js&"
import style0 from "./WaitPick.vue?vue&type=style&index=0&id=c76e1b9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76e1b9c",
  null
  
)

export default component.exports